function r(e) {
  if (e == null) throw new TypeError("Expected a string but received a ".concat(e));
  if (e.constructor.name !== "String") throw new TypeError("Expected a string but received a ".concat(e.constructor.name));
}
export {
  r as default
};
//# sourceMappingURL=contact-channels78.js.map
